// dashboard - DataPie
const DATAPIE_COLOUR_MAP = {
  a: '#d61500',
  b: '#edda34',
  c: '#14d184',
  man1: '#3dc6e5',
  man2: '#2a55e0',
  r: '#b5b5b5',
  u: '#ff7300',
  completed: '#14d184',
  'outstanding.notOverdue': '#ff7300',
  'outstanding.overdue': '#d61500',
};

export default DATAPIE_COLOUR_MAP;
